<template>
  <div>
    <h4 class="font-weight-bold pa-3 mb-0">
      Cost Center

      <employee-profile-payroll-payroll-company-cost-center-dialog-create
        v-if="!companyEmployee.end_date && $hasPermissionTo(['update employee payroll'])"
        :company-employee-uid="companyEmployee.company_employee_uid"
        :company-uid="companyEmployee.company_uid"
        :min-start-date="companyEmployee.company_employee_cost_centers.length > 0 ? companyEmployee.company_employee_cost_centers[0].start_date : companyEmployee.start_date"
        :company-employee-active-cost-center="activeCostCenter"
        @created="$emit('load')"
      />
    </h4> 

    <v-row
      v-if="companyEmployee.company_employee_cost_centers.length > 0"
      class="mx-0"
    >
      <v-col
        v-for="(costCenter, index) in companyEmployee.company_employee_cost_centers"
        :key="costCenter.id"
        cols="4"
      >
        <span class="font-weight-medium">Cost Center:</span>
        <span class="pl-3">{{ costCenter.cost_center.name }}</span> 
        <v-tooltip
          bottom
          min-width="250"
        >
          <template v-slot:activator="{ on: tooltip }">
            <v-icon
              small
              color="info"
              v-on="{ ...tooltip }"
            >
              mdi-information-outline
            </v-icon>
          </template>
          <div>Created by: <b>{{ costCenter.created_by }}</b> on <b>{{ $moment(costCenter.created_at).format('DD-MM-YYYY') }}</b></div>
          <div>Updated by: <b>{{ costCenter.updated_by }}</b> on <b>{{ $moment(costCenter.updated_at).format('DD-MM-YYYY') }}</b></div>
        </v-tooltip>
        <br>

        <span class="font-weight-medium">Start Date:</span>
        <span class="pl-6">{{ $moment(costCenter.start_date ).format('D MMM YYYY') }}</span> 
        <br>
        
        <span class="font-weight-medium">End Date:</span>
        <span class="pl-8 mr-2">{{ costCenter.end_date ? $moment(costCenter.end_date ).format('D MMM YYYY'):'N/A' }}</span> 

        <employee-profile-payroll-payroll-company-cost-center-dialog-edit
          v-if="!companyEmployee.end_date && $hasPermissionTo(['update employee payroll'])"
          :cost-center="costCenter"
          :company-uid="companyEmployee.company_uid"
          :min-start-date="companyEmployee.company_employee_cost_centers.length === index + 1 ? companyEmployee.start_date : $moment(companyEmployee.company_employee_cost_centers[index + 1].end_date).add(1,'d').format('YYYY-MM-DD')"
          :max-end-date="index > 0 ? $moment(companyEmployee.company_employee_cost_centers[index - 1].start_date).subtract(1,'d').format('YYYY-MM-DD') : ''"
          @updated="$emit('load')"
        />
        <employee-profile-payroll-payroll-company-cost-center-dialog-delete
          v-if="!companyEmployee.end_date && $hasPermissionTo(['update employee payroll'])"
          :cost-center="costCenter"
          @deleted="$emit('load')"
        />
        <br>
      </v-col>
    </v-row> 

    <v-row
      v-else
      class="mx-0"
    >
      <v-col
        cols="12"
        class="py-0"
      >
        <span>No Data Available</span>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  export default {
    components: {
      EmployeeProfilePayrollPayrollCompanyCostCenterDialogCreate: () => import('@/components/hris/employee/profile/payroll/payroll-company/cost-center/DialogCreate'),
      EmployeeProfilePayrollPayrollCompanyCostCenterDialogEdit: () => import('@/components/hris/employee/profile/payroll/payroll-company/cost-center/DialogEdit'),
      EmployeeProfilePayrollPayrollCompanyCostCenterDialogDelete: () => import('@/components/hris/employee/profile/payroll/payroll-company/cost-center/DialogDelete'),
    },
    props: {
      companyEmployee: {
        type: Object,
        default: null,
      },
    },
    computed: {
      activeCostCenter () {
        return this.companyEmployee.company_employee_cost_centers.length > 0 && (!(this.companyEmployee.company_employee_cost_centers[0] || {}).end_date) 
          ? this.companyEmployee.company_employee_cost_centers[0] 
          : {}
      },
    },
  }
</script>
